module.exports = __webpack_public_path__ + "static/media/hpm-image-v2.08ceb1ab.jpeg";